import * as dotenv from 'dotenv' 
dotenv.config()
import Vue from 'vue'
import VueRouter from 'vue-router'
import { AuthGuard } from "../guards/routeGuard";

import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Main from "../views/MainPage.vue";
import MainApplication from "../views/MainApplication.vue";
import TopMenu from "../views/TopMenu.vue"
import Agreements from "../views/Agreements.vue"
import Application from "../views/Application.vue"
import CoBorrowers from "../views/Co-Borrowers.vue"
import Documents from "../views/Documents.vue"
import Officer from "../views/Officers.vue"
import Footer from "../views/Footer.vue"

// import { publicPath } from '../../vue.config'

Vue.use(VueRouter)

export const routes = [
  {
    path: "/login",
    name: "login",
    components: {
      default: Login,
      footer: Footer
    }
  },
  {
    path: "/logout",
    name: "logout",
    components: {
      default: Login,
      footer: Footer
    }
  },
  {
    path: "/register",
    name: "register",
    components: {
      default: Register,
      footer: Footer
    }
  },
  {
    path: "/register/invite/:guid",
    name: "invite",
    components: {
      default: Register,
      footer: Footer
    }
  },
  {
    path: "/",
    name: "main",
    components: {
      header: TopMenu,
      default: Main,
      footer: Footer
    }
  },
  {
    path: "/application/:id",
    name: "main-application",
    components: {
      header: TopMenu,
      default: MainApplication,
      footer: Footer
    }
  },
  {
    path: "/application/:id/agreements",
    name: "agreements",
    components: {
      header: TopMenu,
      default: Agreements,
      footer: Footer
    }
  },
  {
    path: "/application/:id/officer",
    name: "officer",
    components: {
      header: TopMenu,
      default: Officer,
      footer: Footer
    }
  },
  {
    path: "/application/:id/co-borrower",
    name: "co-borrower",
    components: {
      header: TopMenu,
      default: CoBorrowers,
      footer: Footer
    }
  },
  {
    path: "/application/:id/fields",
    name: "fields",
    components: {
      header: TopMenu,
      default: Application,
      footer: Footer
    }
  },
  {
    path: "/application/:id/fields/:pageID",
    name: "field",
    components: {
      header: TopMenu,
      default: Application,
      footer: Footer
    }
  },
  {
    path: "/application/:id/documents",
    name: "documents",
    components: {
      header: TopMenu,
      default: Documents,
      footer: Footer
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    redirect: {name: "main"}
  },
];

const router = new VueRouter({
  linkExactActiveClass: "active",
  mode: 'history',
  base: `${process.env.BASE_URL}/`,
  routes,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
})

router.beforeEach(AuthGuard);

export default router
